export default __webpack_public_path__ + "static/media/Fall_01.719fcd20.png";